export { default as Logos } from './Logos';
export { CmsLogos } from './CmsLogos';
